<div class="form-group">
    <label [for]="id" [ngClass]="{ 'text-danger': !valid}">{{label | translate}}</label>
    <ng-select [items]="items" [id]="id" [disabled]="disabled" [bindLabel]="itemLabel" [bindValue]="itemKey"
        [multiple]="multiple" [closeOnSelect]="true" placeholder="{{correctPlaceHolder | translate}}"
        [(ngModel)]="value" [ngClass]="{ 'is-invalid': !valid}">
    </ng-select>
    <small *ngIf="!valid" class="form-text text-muted danger"><em>{{errorMessage}}</em></small>
</div>